import { motion } from "framer-motion";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { useState } from "react";
import { SignupModal } from "@/components/landing/SignupModal";

const PoliticaPrivacidad = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header onOpenModal={() => setIsModalOpen(true)} />
      
      <main className="pt-32 pb-24 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <span className="inline-block text-[#E05D3A] text-sm font-semibold tracking-widest uppercase mb-4">
              Legal
            </span>
            <h1 className="font-outfit text-4xl sm:text-5xl font-light tracking-tight mb-4">
              Política de Privacidad
            </h1>
            <p className="text-zinc-500 mb-12">Última actualización: Diciembre 2024</p>

            <div className="prose prose-invert prose-lg max-w-none space-y-8">
              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">1. Datos que Recopilamos</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p><strong className="text-white">Datos del Coach:</strong> Nombre, email, especialidad, información de facturación, datos de uso, IP, dispositivo.</p>
                  <p><strong className="text-white">Datos del Cliente:</strong> Nombre, edad, sexo, altura, mediciones (10 perímetros, 8 pliegues), peso, fotos, porcentaje de grasa corporal, notas de consulta.</p>
                  <p><strong className="text-white">Grabaciones de Audio:</strong> Consultas, transcripciones generadas por IA, resúmenes y análisis.</p>
                  <p><strong className="text-white">Datos Técnicos:</strong> Cookies esenciales, datos de sesión y autenticación.</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">2. Cómo Usamos los Datos</h2>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Proporcionar y mejorar el servicio</li>
                  <li>Generar resúmenes y análisis con IA</li>
                  <li>Mostrar progreso del cliente</li>
                  <li>Calcular composición corporal</li>
                  <li>Facturación y comunicaciones operativas</li>
                  <li>Análisis estadístico anonimizado</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">3. Procesamiento por Inteligencia Artificial</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p>El audio y texto se procesan mediante IA de terceros (Google Gemini o equivalentes) para generar resúmenes y análisis.</p>
                  <p>Los datos se transmiten encriptados (TLS 1.3). No hay retención en servidores de proveedores de IA más allá del procesamiento en tiempo real.</p>
                  <p>Los proveedores de IA no utilizan datos de usuarios para entrenar modelos.</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">4. Compartición de Datos</h2>
                <p className="text-zinc-400 leading-relaxed mb-4">
                  Los datos no se venden, alquilan ni comparten con fines comerciales. Acceso limitado a:
                </p>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li><strong className="text-white">Coach:</strong> Acceso completo a todos los datos de sus clientes</li>
                  <li><strong className="text-white">Cliente:</strong> Solo vista de progreso (estadísticas, gráficas, puntos clave, fotos). NO transcripciones, audio ni notas privadas</li>
                  <li><strong className="text-white">Proveedores de IA:</strong> Datos encriptados, sin retención</li>
                  <li><strong className="text-white">Proveedores de infraestructura:</strong> Bajo acuerdo de procesamiento de datos (DPA)</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">5. Seguridad de los Datos</h2>
                <p className="text-zinc-400 leading-relaxed mb-4">
                  Implementamos medidas de seguridad estándar de la industria:
                </p>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Encriptación TLS 1.3 en tránsito</li>
                  <li>Encriptación AES-256 en reposo</li>
                  <li>Aislamiento multi-tenant</li>
                  <li>Hash bcrypt para contraseñas</li>
                  <li>Tokens JWT para autenticación</li>
                  <li>Control de acceso basado en roles (RBAC)</li>
                  <li>Auditorías de acceso</li>
                  <li>Copias de seguridad encriptadas</li>
                </ul>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">6. Retención de Datos</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p><strong className="text-white">Cuenta activa:</strong> Mientras la cuenta esté activa y la suscripción vigente.</p>
                  <p><strong className="text-white">Post-cancelación:</strong> 90 días para exportación.</p>
                  <p><strong className="text-white">Copias de seguridad:</strong> Purgadas dentro de 30 días adicionales.</p>
                  <p><strong className="text-white">Grabaciones de audio:</strong> Almacenadas hasta que el coach las elimine.</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">7. Derechos del Usuario</h2>
                <p className="text-zinc-400 leading-relaxed mb-4">
                  Tienes derecho a:
                </p>
                <ul className="text-zinc-400 list-disc pl-6 space-y-2">
                  <li>Acceder a tus datos</li>
                  <li>Rectificar información incorrecta</li>
                  <li>Exportar tus datos</li>
                  <li>Solicitar eliminación</li>
                  <li>Restringir procesamiento</li>
                  <li>Oponerte a ciertos usos</li>
                </ul>
                <p className="text-zinc-400 mt-4">
                  Ejercible mediante configuración de cuenta o contactando a{" "}
                  <a href="mailto:privacy@antropia.app" className="text-[#E05D3A] hover:underline">privacy@antropia.app</a>. 
                  Respuesta dentro de 30 días.
                </p>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">8. Consentimiento de Grabación</h2>
                <div className="text-zinc-400 leading-relaxed space-y-4">
                  <p>Es responsabilidad del coach obtener consentimiento informado antes de grabar.</p>
                  <p>Antropia proporciona un mecanismo de consentimiento digital pero no es legalmente responsable por falta de consentimiento.</p>
                  <p>Se recomienda al coach mantener registros de consentimiento y cumplir con la legislación local.</p>
                </div>
              </section>

              <section>
                <h2 className="font-outfit text-2xl font-medium text-white mb-4">Contacto</h2>
                <p className="text-zinc-400 leading-relaxed">
                  Para consultas de privacidad: <a href="mailto:privacy@antropia.app" className="text-[#E05D3A] hover:underline">privacy@antropia.app</a>
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </main>

      <Footer />
      <SignupModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default PoliticaPrivacidad;
